import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const LotteryIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M14.148 4.72a2.5 2.5 0 0 0-4.296 0a6 6 0 0 0-1.412-.546a4 4 0 0 1 7.12 0a6 6 0 0 0-1.412.546M9.384 7.437a8 8 0 0 1 1.658-.38a5 5 0 1 0-6.986 6.986a8 8 0 0 1 .381-1.659a3.5 3.5 0 0 1 4.947-4.947m10.56 6.605a5 5 0 1 0-6.986-6.986a8 8 0 0 1 1.658.381a3.5 3.5 0 0 1 4.947 4.947q.276.797.38 1.658M9.5 13.25a.75.75 0 0 1 .75-.75h4.25a.75.75 0 0 1 .495 1.313v.001l-.013.011l-.053.05a9.6 9.6 0 0 0-.925 1.048c-.557.731-1.188 1.77-1.53 3.024a.75.75 0 1 1-1.448-.394c.408-1.496 1.152-2.707 1.783-3.538L12.82 14h-2.57a.75.75 0 0 1-.75-.75M12 22a7 7 0 1 0 0-14a7 7 0 0 0 0 14m0-1.5a5.5 5.5 0 1 1 0-11a5.5 5.5 0 0 1 0 11"
      />
    </svg>
  );
};
export default LotteryIcon;
